import createTypes from 'redux-create-action-types';

export default createTypes(
  'GET_ACTIVITY_FEED_REQUEST',
  'GET_ACTIVITY_FEED_SUCCESS',
  'GET_ACTIVITY_FEED_ERROR'
);
